


<app-loader [show]="skeleton"></app-loader>
<div [class.d-none]="skeleton">
  <div class="row">
  <div class="col-md-3 bg-white rounded shadow">
    <div class="pl-3 pr-5">
      <app-navbar [step]="7">
      </app-navbar>
    </div>
  </div>
  <div class="col-md-9">
    <app-breadcrumb [title]="'Transfer Request'"></app-breadcrumb>
  <form [formGroup]="transferRequestForm" (ngSubmit)="save()">
    <input type="hidden" formControlName="id">
    <input type="hidden" formControlName="financialYearId">
    <input type="hidden" formControlName="phaseId">
    <input type="hidden" formControlName="profileId">
    <div class="border rounded p-3 mb-3">
      <div class="row mb-3">
        <label class="col-sm-6 col-form-label" for="isTransfer1">Do you wish to participate in transfer process?</label>
        <div class="col-sm-6">
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" formControlName="isTransfer" name="isTransfer" id="isTransfer1"
              [value]="true">
            <label class="form-check-label" for="isTransfer1">YES</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" formControlName="isTransfer" name="isTransfer" id="isTransfer2"
              [value]="false">
            <label class="form-check-label" for="isTransfer2">NO</label>
          </div>
          <my-error controlName="isTransfer" errorKey="required">Do you wish to participate in transfer process? is required.
          </my-error>
        </div>
      </div>

      <div *ngIf="transferRequestForm.get('isTransfer').value && isPresentPlain()" class="row mb-3">
        <label class="col-sm-6 col-form-label" for="isHardStation1">Willingness to serve at hard stations? (For Plain Station Employee)</label>
        <div class="col-sm-6">
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" formControlName="isHardStation" name="isHardStation"
              id="isHardStation1" [value]="true">
            <label class="form-check-label" for="isHardStation1">YES</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" formControlName="isHardStation" name="isHardStation"
              id="isHardStation2" [value]="false">
            <label class="form-check-label" for="isHardStation2">NO</label>
          </div>
          <my-error controlName="isHardStation" errorKey="required">Willingness to serve at hard stations? is required.
          </my-error>
        </div>
      </div>
    </div>

    <div class="d-flex">
      <!-- <div class="d-flex justify-content-center mb-3">
        <a [routerLink]="['/employee/profile/other-details']" class="btn btn-primary rounded-0">PREVIOUS</a>
      </div> -->
      <button class="btn btn-primary rounded-0 ml-auto mr-2 mb-3" [disabled]="!transferRequestForm.valid || loading"
        type="submit">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
        Submit
      </button>
    </div>
  </form>
</div>
</div>
</div>
